<template>
    <div class="min-h-screen bg-slate-50 flex flex-col justify-between">
        
        <div class="bg-gray-950 px-4 pt-12 pb-6 shrink-0 shadow-md">
            <p class="text-xl font-bold text-white">Configuration du compte</p>
            <p class="text-xs text-orange-400 font-semibold mt-1 uppercase tracking-wider">Dernière étape</p>
            <p class="text-sm text-gray-300 mt-3 leading-snug">
                Veuillez ajouter votre signature ci-dessous pour valider votre compte et accéder à votre espace.
            </p>
        </div>

        <div class="flex-1 p-6 flex flex-col justify-center items-center">
            <div class="w-full max-w-sm bg-white rounded-2xl shadow-sm border border-slate-200 p-6 text-center space-y-4">
                <template v-if="!saving">
                    <div class="w-16 h-16 bg-orange-50 text-orange-500 rounded-full flex items-center justify-center mx-auto mb-2">
                        <svg class="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 009 11a13.916 13.916 0 00-3.139-8.441L5.807 2.47M12 11c0-3.517 1.009-6.799 2.753-9.571m3.44 2.04l-.054.09A13.916 13.916 0 0015 11a13.916 13.916 0 003.139 8.441l.054.09M12 11h.01" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    
                    <h2 class="text-base font-bold text-slate-800">Aucune signature enregistrée</h2>
                    <p class="text-xs text-slate-500 leading-normal px-2">
                        Vous devez ajouter votre signature pour valider votre compte et accéder à votre espace personnel. Cette signature sera utilisée pour valider vos interventions et autres actions nécessitant une preuve de votre identité.
                    </p>

                    <div class="pt-2">
                        <input-signature
                            v-model="signatureUrl"
                            :keyName="'technicien-' + ($route.params.id || 'new')"
                            btn-label="Ajouter ma signature"
                            btn-class="w-full py-3.5 bg-orange-500 active:bg-orange-600 text-white rounded-xl font-extrabold text-sm transition-all shadow-md shadow-orange-500/10 block text-center"
                            @input="handleSignatureUpload"
                        />
                    </div>
                </template>
                <template v-if="saving">
                    <div class="w-16 h-16 border-4 border-orange-200 border-t-orange-500 rounded-full animate-spin mx-auto mb-2"></div>
                    <h2 class="text-base font-bold text-slate-800">Enregistrement en cours...</h2>
                    <p class="text-xs text-slate-500 leading-normal px-2">
                        Veuillez patienter pendant que nous enregistrons votre signature. Cela peut prendre quelques instants.
                    </p>
                </template>
            </div>
        </div>

        <div class="p-4 bg-slate-100 text-center text-[11px] text-slate-400 shrink-0">
            Une fois signée, votre configuration sera instantanément validée.
        </div>

    </div>
</template>

<script>
export default {
    name: 'MobileAddSignature',
    data() {
        return {
            signatureUrl: null,
            saving: false
        };
    },
    methods: {
        async handleSignatureUpload(url) {
            if (!url) return;
            
            this.saving = true;
            let response = await this.$request.post('/account/add-signature', {
                signature: url
            });
            if (response == 1) {
                this.$toast.success("Signature ajoutée avec succès !");
                window.location.href = '/';
            }
        }
    }
};
</script>